import { SvgIcon, type SvgIconProps } from './svgIcon'

export const AmbassadorIcon = ({
  width = 8,
  height = 24,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 8 20" {...props}>
    <svg
      width="8"
      height="20"
      viewBox="0 0 8 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.70711 0.292893C1.89464 0.105356 2.149 0 2.41421 0H5.58579C5.851 0 6.10536 0.105357 6.29289 0.292893L6.78149 0.781492C6.91541 0.915408 6.96217 1.11349 6.90228 1.29316L6 4H2L1.09772 1.29316C1.03783 1.11349 1.08459 0.915408 1.21851 0.781492L1.70711 0.292893Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8 17L4 20L0 17L2 5H6L8 17ZM4 18.1201L6.37012 16.4004L4.65039 6.5H4V18.1201Z"
        fill="currentColor"
      />
    </svg>
  </SvgIcon>
)
